




























































































































































































































































































































import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            loading: false,
            toolbar: {
                title: 'Migration',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            },
            faqs: [
                {
                    question: 
                        'Do I lose my MessageDesk Reach account?',
                    answer: 
                        'No, your MessageDesk Reach account is not deleted ' +
                        'and data can be moved to Inbox by MessageDesk ' +
                        'multiple times. Your original account remains ' +
                        'accessible and functional.'
                },
                {
                    question: 
                        'Can I test Inbox by MessageDesk before moving ' +
                        'my number over?',
                    answer: 
                        'Yes! If you wish to use Inbox by MessageDesk ' +
                        'before moving your number you can and is highly ' +
                        'recommended. Moving your number to Inbox by ' +
                        'MessageDesk is instant but moving the number back ' +
                        'to Reach requires messaging support.'
                },
                {
                    question: 
                        'What data is migrated during the migration ' +
                        'process?',
                    answer: 
                        'The migration process transfers your contacts ' +
                        '(including addresses and email information), ' +
                        'messages (including media attachments), message ' +
                        'templates, custom fields, groups (which become labels) ' +
                        'and opt-out lists. All ' +
                        'data is preserved with its original structure and ' +
                        'metadata.'
                },
                {
                    question: 
                        'How long does the migration process take?',
                    answer: 
                        'The time required depends on the amount of data ' +
                        'you have. Data migration runs in the background ' +
                        'and you\'ll receive a notification when it\'s ' +
                        'complete. Phone number migration is instant once ' +
                        'initiated.'
                },
                {
                    question: 
                        'Can I use both MessageDesk Reach and Inbox by ' +
                        'MessageDesk at the same time?',
                    answer: 
                        'Yes, you can use both platforms simultaneously ' +
                        'until you migrate your phone number. Once your ' +
                        'phone number is migrated, all text messages will ' +
                        'be handled by Inbox by MessageDesk, but your ' +
                        'Reach account will remain accessible for viewing ' +
                        'historical data.'
                },
                {
                    question: 
                        'What happens if I need to move my phone number ' +
                        'back to MessageDesk Reach?',
                    answer: 
                        'You can always move your phone number back from ' +
                        'Inbox by MessageDesk if you choose. However, ' +
                        'moving the number back requires contacting support.'
                },
                {
                    question: 
                        'Will there be any downtime during migration?',
                    answer: 
                        'No, there is no downtime during the data ' +
                        'migration process. Your MessageDesk Reach account ' +
                        'remains fully functional. Phone number migration ' +
                        'happens instantly.'
                },
                {
                    question: 
                        'What if something goes wrong during migration?',
                    answer: 
                        'If you encounter any issues during migration, ' +
                        'please contact support immediately. Your data ' +
                        'remains safe in your MessageDesk Reach account, ' +
                        'and you can retry the migration process. Data ' +
                        'migration can be run multiple times if needed.'
                },
                {
                    question: 
                        'Do I need to do anything after the migration ' +
                        'is complete?',
                    answer: 
                        'After data migration completes, you\'ll want to ' +
                        'verify that all your contacts, messages, and ' +
                        'templates have been transferred correctly in ' +
                        'Inbox by MessageDesk. Once you\'re satisfied, ' +
                        'you can proceed with migrating your phone number ' +
                        'when you\'re ready.'
                },
                {
                    question: 
                        'Will my team members and permissions be ' +
                        'migrated?',
                    answer: 
                        'Team members and user permissions are managed ' +
                        'separately in Inbox by MessageDesk. You\'ll need ' +
                        'to invite your team members to your new Inbox by ' +
                        'MessageDesk workspace and configure their ' +
                        'permissions there.'
                }
            ]
        }
    },
    computed: {
        authIsSupport(): boolean {
            return this.$store.getters.authIsSupport
        },
        canMigratePhone(): boolean {
            return this.$store.getters.authIsAdmin
                || this.authIsSupport
        },
        v2Data(): Record<string, unknown> | null {
            const s = this.$store.getters.settingGet('canMigrateToV2')
            return (s && s.data) ? s.data : null
        },
        isConnected(): boolean {
            return this.v2Data && this.v2Data.connected === true
        },
        lastMigration(): string | null {
            const v = this.v2Data && this.v2Data.lastMigration
            return typeof v === 'string' ? v : null
        },
        isDataMigrationCooldown(): boolean {
            if (this.authIsSupport) return false
            if (!this.lastMigration) return false

            const ms = 24 * 60 * 60 * 1000
            return (Date.now() - new Date(this.lastMigration).getTime()) < ms
        },
        isPhoneMigrated(): boolean {
            return this.v2Data && this.v2Data.phoneMigrated === true
        },
        lastMigrationFormatted(): string {
            if (!this.lastMigration) return ''
            try {
                const d = new Date(this.lastMigration)
                const dateStr = d.toLocaleDateString(undefined, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                })
                const timeStr = d.toLocaleTimeString(undefined, {
                    hour: 'numeric',
                    minute: '2-digit'
                })
                return `${dateStr} ${timeStr}`
            } catch {
                return this.lastMigration
            }
        }
    },
    methods: {
        //  This function is the only one with the callback as all we care 
        //  about is if they're connected or not, doing this allows us to 
        //  disable the connect button only upon successful submission
        popConnectionPrompt(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-connection',
                title: 'Connect With 2.0',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "1"
                },
                closeable: true,
                closeOnSubmit: true,
                callback: () => {
                    this.$store.dispatch('settingsGet')
                }
            })
        },
        popMigratePrompt(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-folder-move',
                title: 'Begin Data Migration',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "2"
                },
                closeable: true
            })
        },
        popDateRangeMigratePrompt(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-calendar-range',
                title: 'Migrate Data by Date Range',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "2",
                    dateRangeMode: true
                },
                closeable: true
            })
        },
        popPhonePrompt(): void {
            if (!this.canMigratePhone) {
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Button Disabled',
                    text:
                        "You don't have permission to access this " +
                        "feature. Only the account admin can migrate the phone number.",
                    icon: 'mdi-alert',
                    color: 'primary',
                    closeable: true
                })
                return
            }

            //  Pop our phone migration dialog
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-phone',
                title: 'Migrate Phone Number',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "3"
                },
                closeable: true
            })
        }
    }
})
